import React, { Component } from "react";
import { Container } from "reactstrap";
import DataWrapper from "../../../principal/containers/DataWrapper";
import { observer, inject } from "mobx-react";
import FiltroConsultaEdiNf from "../componentes/FiltroConsultaEdiNf";
import NotaFiscalTransporteStore from "../stores/NotaFiscalTransporteStore";
import TabelaConsultaEdiNf from "../componentes/TabelaConsultaEdiNf";
import Footer from "../../../comum/components/Footer";
import FooterContent from "../../../comum/components/FooterContent";

@inject("store")
@DataWrapper
@observer
export default class ConsultaEdiNf extends Component {
  constructor(props) {
    super(props);

    this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    this.appStore = this.props.store.appStore;

    this.store = new NotaFiscalTransporteStore();
    this.appStore.showVoltarTopBar(true, "/agendamento-nota-fiscal");
  }

  componentDidMount() {
    this.tituloPaginaStore.setTitulo("Consulta EDI NF");
    this.store.listar();
  }

  render() {
    const qtdeDados = this.store.dados.length;
    return (
      <div>
        <Container fluid>
          <FiltroConsultaEdiNf
            filtros={this.store.filtros}
            listar={() => this.store.listar()}
          />
          <TabelaConsultaEdiNf
            dados={this.store.dados}
            colunas={this.store.colunas}
            loading={this.store.loading}
          />
        </Container>
        <Footer>
          <FooterContent>
            {qtdeDados > 0 && (
              <div className="justify-content-between">
                <div>
                  <b>{qtdeDados}</b> registro{qtdeDados > 1 ? "s" : ""}
                </div>
              </div>
            )}
          </FooterContent>
        </Footer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/nota-fiscal-transporte/edi/telas/ConsultaEdiNf.js